export default __webpack_public_path__ + "static/media/close.3ec9d11e.svg";